// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2UQ2L","empty":"ModalGraph_empty__1XT0o"};